import { render, staticRenderFns } from "./textSpacingController.vue?vue&type=template&id=7df7baff&"
import script from "./textSpacingController.vue?vue&type=script&lang=ts&"
export * from "./textSpacingController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports